import React from 'react';

import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useBookingMachine} from '../../hooks/useBookingMachine';
import {BrandButton} from '../../lib/brand-button/brand-button';


export const BookingNotifyHostButton = () => {
  const {t} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();

  const handleNotifyHost = () => {
    bookingActor.send({type: 'notifyHost.go'});
  };

  return (
    <EmptyState
      imageVariant="calendar"
      title={t(
        'No_available_date_time_found_for_host',
        'No available date & time found for host',
      )}
      description={t(
        'Please_notify_the_host_of_this_meeting_that_there_are_no_available_time_slots',
        'Please notify the host of this meeting that there are no available time slots',
      )}
    >
      <BrandButton onClick={handleNotifyHost}>
        {t('Notify_host', 'Notify host')}
      </BrandButton>
    </EmptyState>
  );
};
